function TestPage() {
  return (
    <div style={{ padding: '40px' }}>
      <h1>Test Page Works!</h1>
      <p>If you see this, basic routing is working.</p>
    </div>
  )
}

export default TestPage
